module.exports = __webpack_public_path__ + "static/img/shuchuang_hover.cae6d03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/shuchuang_hover.png
// module id = 741
// module chunks = 1